import React from 'react';
import BoxPlot from '../BoxPlot/BoxPlot';

const VisBoxPlots = (props) => {

  const { data, highlights } = props;

  const margin = {top: 75, right: 30, bottom: 75, left: 155};
  const domain = [-2,5];

	return (
		<BoxPlot
			title="Boxplot koopkrachtontwikkeling"
			background="none"
			colorBox="#e5b2cf"
			colorMedian="#fff"
			boxHeight={15}
      source="Fictieve cijfers"
      margin={margin}
			data={data.groepen}
			domain={domain}
      highlights={highlights}
		/>
	)
}

export default VisBoxPlots;



// WEBPACK FOOTER //
// ./src/components/Visualization/VisBoxPlots.js